<template>
     <div class="main">
    <div class="bg">
        <p class="title">亲爱的校友：您未认证校友，请扫描二维码进行校友认证</p>
    </div>
</div>
</template>

<script>
export default {
    name: 'qrcode',
    data(){
        return{

        }
    },
    methods: {
        test(){
           this.$router.push({ name: 'checkPhone'})
        }
    }
}
</script>
<style scoped>
 .main{
      background: #F9FAFE;
      display: flex;
      justify-content:center;
      align-items: center;
      height: 100vh;
  }
  .bg{
      background: url("../../../assets/img/qrcode.jpg") no-repeat;
      width: 855px;
      height: 443px;
      background-position: center;

  }
  .bg p{
    font-size: 16px;
    color: #333;
    padding-left: 250px;
    padding-right: 50px;
  }
  .title{
      margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/page/officialEmail/qrcode/index.vue